import React from 'react';
import {Typography} from "@mui/material";
import clsx from "clsx";
import {getStore} from "trim-redux";
import {getDirection} from "../../../config/design/theme";

export default function Title(props) {
    return (
        <Typography
            ref={props.ref}
            style={props.style}
            component={!!props.component ? props.component : "h2"}
            variant="h6"
            to={props.to}
            className={clsx("heading",props.className)}
            color={props.color ? props.color : "primary"}
            align={props.align ? getDirection() === "rtl" ? props.align === "left" ? "right" : "left" : props.align : "center"}
            gutterBottom
        >
            {props.children}
        </Typography>
    );
}
